/**
 * Chinese Simplified
 */

const locale = {
    schedule: {
        "Lesson Color": "课程颜色",
        "Select": "选择",
        "Same date will only create single lesson": '日期相同时创建单次课节',
        'Class': '班级',
        'Select Class To Add Lesson': '选择班级进行排课',
        'Search Class': '搜索班级',
        calendar: {
            "month": "月课表",
            "week": "周课表",
            "day": "日课表",
            "Attended": "已签到",
            "Lesson": "课节",
            "Previous Week": "上一周",
            "Previous Month": "上一月",

      "Next Week": "下一周",
            "Next Month": "下一月",

      "Yesterday": "昨天",
      "Today": "今天",
      "Tomorrow": "明天",

    },
        'Attended lesson cannot be moved': '已签到的课节不能被移动！',
        '(Lesson {lesson_number})': '(课节 {lesson_number})',
        'Time: {time}': '上课： {time}',
        'Classroom: {classroom}': '教室： {classroom}',
        'Student: {number}': '学员： {number} 人',
        "Attended": "已签到",
        'Unattended': '未签到',
        'All Teachers': '所有老师',
        'All Classes': '所有班级',
        'All Classrooms': '所有教室',
        'All Students': '所有学员',
        'Add Lesson': '添加课程',

    'Student': '学员',
    'Select Student': '选择学员',
    'Search Student': '搜索学员',
    'Teacher': '老师',
    'Select Teacher': '选择老师',
    'Search Teacher': '搜索老师',
    'Classroom': '教室',
    'Select Classroom': '选择教室',
    'Search Classroom':'搜索教室',
    'Select Class': '选择班级',
    'Search Class': '搜索班级',
        'There was a conflict while moving the lesson.': '移动课程时发生了冲突',
        'Conflicts': '冲突',
        'Print Schedule': '课表打印'
  },
    header: {
        "Change Language": "切换语言",
        "Premium Version": "升级高级版",
        "Privacy": '隐私政策',
        "Settings": '查看资料',
        "Switch School": '切换学校',
        "Personal Settings": '个人设置',
        "Sign Out": "登出",
        "Payment Information": '支付信息',
        "Please Enter Payment Information In Order To Upgrade To Permium Version ($79 USD per month per school), Invoice Will Be Sent Eletronically Via Email Every Month": '请填写您的支付信息以确保您能正常使用高级版 (每月每學校$79 USD), 我们会通过邮件发送每个月的帐单',
        'You are about go over the school limit, please upgrade to higher subscription plan to add more schools': '您即将超出现计划包含的学校上限，请先升级至更高计划再创建更多学校。',
        'You are about go over the teacher limit, please upgrade to higher subscription plan to add more teachers': '您即将超出现计划包含的老师上限，请先升级至更高计划再创建更多老师。',
        'You are about go over the student limit, please upgrade to higher subscription plan to add more students': '您即将超出当前计划包含的学生上限，请先升级至更高计划再创建更多学生。',
        'Upgrade Subscription Plan': '需要升级计划',
        sidemenu: {
            "My channels": "我的频道",
            "Schedules": "课表",
            "Students": "学员",
            "Classes": "班级",
            "Private Classes": "私课",
            "Teachers": "老师",
            "Classrooms": "教室",
            "Announcements": "公告",
            "Statement Detail": "收支明细",
            "Monthly Summary": "月度汇总",
            "School Management": "学校管理",
            "School Administration": "教务权限",
            "School Information": "学校信息",
            "Sales Management": "销售管理",
            'Posters': '海报',
            'Contacts':'联系人'
        },
        panelmenu: {
            "Administration Management": "教务管理",
            "Financial Management": '财务管理',
            "School Management": '学校管理',
            "Sales Management": '营销管理',
            'This feature is under development': '此功能正在开发中'
        },
        'Add Clients': '新增潜在客户',
        '': '',
        '': '',
    },
    checkoutform: {
        "Your purchase is successful!": "购买成功！",
        "Email Address": "邮件地址",
        "Credit Card": "信用卡资料",
        "Submit Payment": "购买",
        "Please Enter Email Address!": "必须填写邮件地址！",
        "Pay":"确认付款"
    },
    appwrapper: {
        "All field must be filled!": "请填写所有信息来创建学校",
        "Please enter your phone number": "请输入您的手机号",
        "Next ": '下一步 ',
        "Verify your phone number": "验证您的手机号",
        "Verification code can be resent in {counterTime} seconds ": "{counterTime}秒后可重新发送 ",
        "Resend verification code": '重新发送验证码',
        "Code": "验证码",
        "Verification Code": "输入验证码",
        "New Password": '新密码',
        "Register": "注册",
        "Send Verification Code": "发送验证码",
        "Verify your phone number": "验证您的手机号",
        'Register Successful': '注册成功',
        'Create School': '创建学校',
        'School Information': '创建新学校必填内容',
        "School Name": '学校名字',
        "School Description": '学校简介',
        'School Type': '学校类型',
        'After School Class': '课后辅导班',
        'Pre School': '学前班',
        "Tutor": '家教',
        "The verification code is sent to: {phone}": '您的手机 {phone} 会收到验证短信',
        'Login account: {phone}': '登录账号： {phone}',
        'Public/Private School': '公校/私校',
        'Student Enrollment Age Limit': '招收学员年龄下限',
        'Years Old': '岁',
        '{age} year old': '{age} 岁',
        '{age} years old': '{age} 岁',
        'Country': '选择国家',
        'Province/States': '选择地区',
        'City': '输入城市',
        'Time Zone (Cannot Change After Saved)': '时区 (一旦保存不可更改)',
        'Currency (Cannot Change After Saved)': '货币种类 (一旦保存不可更改)',
        'Complete': '完成',
        'Sign In': '登入',
        'Forgot Password': '忘记密码',
        'Register New Account': '注册帐户',
        'Agent ID (Optional)': '销售人员号码 (选填)',
        'User already registered, please sign in or sign up with different phone number': '此用户已经存在，请登录，或用其他手机进行注册',
        'The Phone No./Password combination is not valid': '手机号/密码组合错误',
        'Password must be at least 6 characters': '密码需要超过6个字符',
        'Incorrect PIN': 'PIN 不正确',
        'PIN expired': 'PIN 过期',
        'By clicking Register, you agree to our ': '点击「注册」即表示你同意我们的',
        'Terms of Service': '使用条款',
        '/terms-of-service/en': '/terms-of-service/cn',
        'https://base.classtop.com/terms-of-service-en.html': 'https://base.classtop.com/terms-of-service-cn.html',
        'Already a user?': '已经是用户？',
        "For better user experience, please use 'ClassTopBase' on computer or tablet.": "为了更好地使用体验, 请在电脑上使用 ’ClassTopBase‘",
        'Or try our mobile app!': '或者尝试使用我们的手机程序',
        'Not a user?': '不是用户？',
        'Download admin app': '下载管理员 app',
        'Download teacher app': '下载老师 app',
        'Download student app': '下载学生 app',
        'Sign up': '注册',
        "Sign up successful, please download our app!": "注册成功，请下载我们的应用！",
        'Start Using': '开始使用',
        "Invalid email address!": "请填写正确格式的邮箱",
        'Resent in {counterTime} s': '{counterTime} 秒后可重发',
        'Invalid phone number!': '手机号格式错误',
    },
    changeschool: {
        "You are over the school limit, please upgrade to Premium Version and purchase additional schools": "您目前的校区已上限, 添加更多校区请升级为高级版并且购买更多校区",
        "Create a new school ($79 USD per month per school), invoice will be sent eletronically via Email every month ": '创建新的一所学校 (每个月每学校$79 USD), 我们会通过邮件发送每个月的帐单',
        "Cancel": '取消',
        "Save": '确认',
        ' Create New School': ' 创建新学校',
        'Create School': '创建学校',
        'School Created': '创建成功',
        'Principal': '校长',
        'Teacher': '老师',
        'Decline': '拒绝',
        'Accept': '接受',
        'Delete School: {school_name}?': '确认删除学校: {school_name} ?',
        " Delete": ' 删除',
        "Exit School: {school_name}?": "确认退出学校: {school_name} ?",
        " Exit": ' 退出',
        'My School': '我的学校',
        "Delete School": '删除学校',
        " Back to My School": ' 返回我的学校',
        '$79 USD / month per school': '每学校每个月 $79 USD',
        'Please Enter Valid Information': '输入正确的资料',
        'Payment Failed': '购买失败',

    },
    administration:{
        "Permission Management for group": "权限管理",
        "Read Students": "读取学员",
        'Edit Students': '更改学员',
        'Read Classes': '读取班级',
        'Edit Classes': '更改班级',
        'Read Teachers': '读取老师',
        'Edit Teachers': '更改老师',
        "Read Classrooms": '读取教室',
        'Edit Classrooms': '更改教室',
        'Read Finance': '读取财务',
        "Edit Finance": '更改财务',
        'Read Attendances': '读取签到',
        "Edit Attendances": '更改签到',
        "Read Lessons": '读取课节',
        "Edit Lessons": '更改课节',
        'Read Announcements': '读取公告',
        'Edit Announcements': '更改公告',
        'Read Permissions': '读取权限',
        'Edit Permissions': '更改权限',
        'Cannot delete this group': '无法删除角色组',
        'Delete this group': '删除此角色组',
        'Proceed to create new group? (all the unsaved data will be deleted)': '是否離開編輯此角色組（未储存的资料将会被删除）',
        'Teacher Group cannot be deleted, but can edit persmisison and personnel': 'Teachers组为默认角色组，不可删除，您可以修改Teachers组的权限、增加或删除组内人员，或创建新的角色组',
        'Delete Group {group_name} ?': '确认删除角色组：{group_name} ?',
        'Create New Group': '创建新角色组',
        " Edit": ' 编辑',
        'Group Members': '角色组成员'
    },
    createadministration: {
        'New Group Name': '新角色组名称',
        "Add": '添加',
        "Added": '已添加',
        'Select Teacher': '选择老师',
        'Search Teacher': '搜索老师',
        "Add Member": '添加成员',
        "Please enter a group name": '请填写角色组名称',
        'Please select permissions': '请选择权限',
        "Please select members": '请选择成员',
        ' Back': ' 返回'
    },
    announcement: {
        "All Classes and Students" : '全体师生',
        "Delete Announcement: {title}": '确认删除公告：{title} ？',
        "Announcer: ": "发布者：",
        'Date/Time: ': '发布时间：',
        'Send To: ': '发布送至： ',
        'Please enter announcement title': '请输入通告标题搜索',
        'All': '全部',
        'New Announcement': '新建公告',
        'Edit Announcement': '编辑公告',
        'Please Enter Announcement Title': '请填入公告标题后才可以发布',
        'For: ': '公告对象: ',
        'Title: ': '公告标题： ',
        'Automatic Mailing (to students) and SMS (to teachers) Announcement System': '自动发邮件（针对学员）与短信（针对老师）的公告系统',
        'Here you can create announcements for all teachers and students, as well as specific classes. When the announcement is published, the system will automatically send the announcement via email to students and SMS to teachers': '在这里您可以创建针对全体老师和学生的公告，也可针对指定班级发布公告。在您创建的公告发布的时候，系统会自动将公告内容给学生发邮件、给老师发手机短信。',
        '': '',
    },
    attendance:{
        " Attendance Record": " 签到记录"
    },
    class: {
        'New Class: {new_cname} Has Been Created!': '新班级 {new_cname} 已创建！',
        'Class: {cname} Has Been Updated!': '班级 {cname} 已更新！',
        'Class: {cname} Has Been Archived': '班级 {cname} 已归档',
        'Class: {cname} Has Been Unarchived': '班级 {cname} 已恢复归档',
        'Class: {cname} Error': '班级 {cname} 操作失败',
        'Class Status Update Failure: Network Connection Issue!': '班级状态更新失败：Network connection issue!',
        'Class: {cname} Archived?': '确认对 {cname} 班级进行归档？',
        'Lesson Scheduled': '已排课',
        'Lesson Started': '已开始上课',
        "Archived": '归档',
        "Unarchive": '恢复归档',
        'Select': '选择',
        "View": '查看',
        "Edit": '编辑',
        'Close': '关闭班级',
        'Search Class': '请输入关键词搜索',
        'History': '历史班级',
        'New Class': '新增班级',
        'Class Name': '班级名称',
        'Date': '日期',
        'Lesson Amount': '课节数',
        'Teachers': '老师',
        'Price': "总价",
        'Students': '学员',
        'Past Students': '历史学员',
        'Status': '状态',
        'Settings': '操作',
        'Lesson Status':'上课进度',
        'View':'进入班级',
        'Add Lesson': '排课',
        'Attendance': '签到',
        'Scheduled': '已排课',
        'Not Scheduled': '未排课',
        'Closed Class': '已关闭班级',
        'Current Class': '当期班级',
        'Class List': '班级列表',
        'Proceed to restore class?': '确认恢复班级？',
        'Class Description': '班级简介',

        'Class Management is Suitable for all Teaching Scenarios': '适用于所有教学场景的班级体系',
        'Class Management allows you to create classes, schedule lessons, auditions. attendance, appoint teachers and classrooms. Each class can be designed to be billed by lesson, date, or hour to keep track of the class status. It will also remind you when there is conflict between different classes.': '创建班级，排课，补课，试听，签到，设置任课教师，教室。大到几千人，小到几个人。可按期，按次，按时等跟踪课程进度。智能冲突系统可有效的提醒学校资源的重叠使用。自由的排课系统满足任何您需要的班级体系。',
    },
    createnewclass:{
        'Create Class Failure': '班级创建失败',
        'Class Teacher Update Failure': '班级老师更新失败',
        'Class Student Update Failure': '班级学员更新失败',
        'All Fields with * Must Be Filled': '带*号的字段必须填写',
        '{i} Day Remaining' : '剩余 {i} 天提醒',
        'Notify me when...': '提醒时间',
        '{i} Lesson Remaining': '剩余{i}节课提醒',
        '{i} Hour Remaining': '剩余{i}小时提醒',
        'Create New Class': '新增班级',
        'Enter Class Name': '输入班级名称',
        'Billing Types': '计费类型',
        'Bill by date': '按日期计费',
        'Bill by lessons': '按课次计费',
        'Bill by hours': '按小时计费',
        'Student Number': '招生人数',
        '': '人',
        'Lesson Completion Rules': '课消规则',
        'Attending counts as completion': '按签到算课消',
        'Absence (with reason) counts as completion': '请假算课消',
        'Absence (without reason) counts as completion': '缺课算课消',
        '':'',
    },
    editclass: {
        'Class Update Failure': '班级更新失败',
        'Edit Class': '编辑班级',
        'Class': '班级'
    },
  classdetail:{
    '1 week': '一周',
    '2 weeks': '两周',
    '3 weeks': '三周',
    '4 weeks': '四周',
    '5 weeks': '五周',
    '6 weeks': '六周',

    '1 day': '一天',
    '2 days': '两天',
    '3 days': '三天',
    '4 days': '四天',
    '5 days': '五天',
    '6 days': '六天',

    'By Week': '按周',
    'By Day': '按天',
    'By Month': '按月',
    'Refund & Exit Class': '退款以及退班',
    'Proceed to refund and remove the student, {student_name}, from class?': '确认退款以及退班({student_name}学员)吗？',
    'Not Assigned': '未定',
    'Attended': '出勤',
        'Class: {cname} Has Been Updated!': '班级 {cname} 已更新！',
        'Lesson Teacher Updated': '课节老师已更新',
        'Lesson Teacher Update Failure': '课节老师更新失败',
        'New Lesson: {new_name} Saved': '新课节 {new_name} 已保存',
        'Lesson Name Update Failure': '课节名称更新失败',
        'Lesson Deleted': '课节已删除',
        'Lesson Delete Failure': '删除课节失败',
        'Lesson: {lesson_name} Added': '课节: {lesson_name} 已添加',
        'Add Lesson Failure': '添加课节失败',
        'Student Has Exited Class': '学员已退班',
        'Student Exit Class Failure': '学员退班失败',
        'Student: {studnet_name} refunded {amount_of_money} {currency} successful!': '学员: {student_name} 退款 {amount_of_money} {currency} 成功！',
        'Student: {studnet_name} added credit {amount_of_money} {currency} successful!': '学员 {student_name} 充值 {amount_of_money} {currency} 成功！',
        'Student: {studnet_name} charged {amount_of_money} {currency} successful!': '学员 {student_name} 收费 {amount_of_money} {currency} 成功！',
        "Delete {name}'s Lesson?": '确认删除 {name} 的课节?',
        'Class Price': '课程总价',
        'Payment Reminder': '欠费提醒',
        'Past Lesson Counts': '已上课节',
        'Enrollment Status': '招生情况',
        'Checked In': '已签到',
        'Check In': '签到',
        'Remaining ': '余 ',
        'Overdue ': '欠费 ',
        'Exited Class': '已退班',
        'Student Detail': '学员资料',
        'Remarks': '备注',
        'Exit Class': '退班',
        'Exit Student: {name} From Class?': '确认对学员 {name} 进行退班?',
        'Exit Teacher: {name} From Class?': '确认对老师 {name} 进行退班?',
        'Refund and Exit Class': '退款并退班',
        'Add Student': '添加学员',
        'Search Students': '搜索学员名称...',
        '{age} Years Old': '{age} 岁',
        'Attendance': '出勤签到',
        'Lesson Completion Rule: ': '课消规则：',
        'Lesson Time: ': '上课时间：',
        '{lsnStartDate1} - {lsnStartDate2} - {lsnStartDate3}  {lsnStartTime} - {lsnEndTime}': '{lsnStartDate1}年{lsnStartDate2}月{lsnStartDate3}日 {lsnStartTime} - {lsnEndTime}',
        'None':'无',
        'Leave of Absence': '请假',
        'Late': '迟到',
        'Absence': '旷课',
        'Total of {total_amount} person {total_amount2} Attended': '共 {total_amount} 人 出勤 {total_amount2} 人',
        'Lesson': '课节',
        'Insufficient Account Balance, Please Top Up and Try Again': '当前您的钱包余额不足，请充值后再使用',
        'Insufficient Balance. Please Top Up or Try Other Payment Options': '当使用钱包余额时，收款金额不能大于钱包余额！为了正常交易，您可以先充值在使用钱包或使用其他交易方式',
        'Exit Class Until': '退课期至',
        'Exit Class Number': '退课次',
        '': '次',
        'Account Balance: ': '钱包余额: ',
        'Refund': '退款',
        'Refund Tuition': '直接退学费',
        'Refund Date': '退款日期',
        'Class': '班级',
        'Refund Options': '退款方式',
        'Cash': '现金',
        'Credit Card': '信用卡',
        'Cheque': '支票',
        'Bank Transfer': '转账',
        'Account Balance': '校内钱包',
        'Email': '邮箱',
        'Paper Receipt Number': '纸质收据号',
        'Send Receipt To Parents': '电子收据会通过邮件发给家长',
        'Exit Student: {sname} From Class?': '确认对学员： {sname} 退班?',
        'Refund Date Cannot Be Empty': '退款日期不能为空',
        'Proceed To Refund transaction and Exit Class For Student: {sname} ?': '确认对学员 {sname} 进行退款和退班?',
        'Same date will only create single lesson': '日期相同时创建单次课节',
        'Start Date Must Be Earlier Than End Date': '开始日期必须早于或等于结束日期',
        'End Date Must Be Later Than Start Date': '结束日期必须晚于或等于开始日期',
        'End Time Must Be Later Than Start Time': '结束时间必须晚于开始时间',
        'Please Select Lesson Date and Time': '请选择课节日期和时间',
        'End Date/Time Must Be Later Than Start Date/Time': '结束日期或时间必须晚于开始日期或时间',
        'Please Select Days': '请选择周中日期',
        'Please Select Dates': '请选择月中日期',
        'Please Select Lesson Date': '请选择课节日期',
        'Select Student': '选择学员',
        'Search Student': '搜索学员',
        'Select Classroom': '选择教室',
        'Search Classroom':'搜索教室',
        'Every': '每',
        '(Can Select Multiple)': '(可多选)',
        'Frequency': '频率',
        'Start Date': '开始日期',
        'End Date': '结束日期',
    'Start Time (HH:MM)': '上课时间 (HH:MM)',
        'End Time (HH:MM)': '下课时间 (HH:MM)',
        'Batch Scheduling': '批量排课',
        'Lesson Has {student} Students': '班级学员 {student} 人',
        'Student: {student}': '班级学员: {student}',
        'Select': '选择',
        'Classroom': '教室',
        'Conflict': '冲突',
    'There are conflicts while creating a lesson.': '排课时发生冲突',
    'One or more teachers are occupied during this period.': '部分老师在这个时间段已排过课',
    'One or more students are occupied during this period.': '部分学生在这个时间段已被排过其他课程',
    'The classroom is in use during this period.': '教室在这个时间段已排过课',
    'Lesson Date': '上课日期',
        'Delete Lesson': '删除这一课节',
        'ID': '序号',
        'Lesson Time': '上课时间',
        'Student Counts': '学员人数',
        'Class Student': '班级学员',
        'Lesson Count': '排课课次',
        'Lesson Status': '上课进度',
        'Checked In': '已签到',
        'Please Select': '请选择...',
        "When 'Account Balance' reaches 0, student: {name} will automatically exit class": '输入‘退款金额’为0时，执行‘确定’后将学员 {name} 直接退出班级',
    'Please Select Class and Enter Refund Amount': '请您首先选择班级，并填入退款金额',
        'Proceed to delete class?': '确认删除班级？',
        'Upcoming Lesson': '未来课节',
        'Past Lesson': '过去课节',
    'Remark':'备忘',

    },
    classone: {
        'New class: {cname} Has Been Created': '新班级： {cname} 已创建',
        'Class: {cname} Has Been Updated': '班级： {cname} 已更新',
        'Class: {cname} Archived': '班级： {cname} 已归档',
        'Class: {cname} Unarchived': '班级： {cname} 已恢复',
        'Class: {cname} Failure': '班级： {cname} 操作失败',
        'Class Status Update Failure': '班级状态更新失败',
        "Proceed to delete private class?" : "确认删除私课",
        "Proceed to restore private class?" : "确认恢复私课",
        'Scheduled': '已排课',
        'Class Started': '已开始上课',
        'Search Students': '请输入学员名称搜索',
        'Current': '当期私课',
        'Closed Private Class': '已关闭私课',
        'New Private Class': '新增私课',
        'Student Name': '学员名称',
        'Private Class Name': '私课名称',
        'Enter Private Class Name': '输入私课名称',
        'View': '进入私课',
        'Private Class List': '私课列表',
        'Close': '关闭私课',

        'Flexible Private Class Management': '灵活多变的私课',
        'Private Class Management is not limited to just one on one lesson, it can also be used as auditions, interviews, and more. Just like Class Management, it allows you to appoint teacher and classrooms.': '私课不仅仅指一对一的教学形式，这里还可以用于补课，试听，interview等多种应用方式。别忘了，老师，教室和授课时间也是影响私课的重要因素哦。',
        '': '',
    },
    schoolInformation: {
        "School Information": "学校基本信息",
        "Add all information that will help your target audience better understand your school on our Yellow Pages advertisements": "填写完善的信息，将有助于您在黄页上更清晰的展现您的学校",
        form: {
            'Address': '地址',
            "School Name": "学校名称",
            "School Logo": "学校logo",
            "About School": "学校简介",
            "School Website": "学校官网主页",
            "Time Zone": "时区",
            "Currency": "货币种类",
            "School Phone Number": "学校联系电话",
            "School Email": "学校联系Email",
            "School Type": "学校类型",
            "Categories": "课程种类",
            "Student Age": "招收学员年龄",
            'School Address': '学校地址',
            'Class Categories': '课程种类',
            'Click or drag and drop image here': '点击或将图片拖放到这里',
            'Max file size: 5 MB': '最大文件尺寸：5 MB',
            "Open Hours": '营业时间',
            "Update Info": '更新信息',
            "Student Registration Agreement": "学员注册条款",
            "Notify admin via email when contact converted to student": "联系人转化学员时通知运营人员",
        },
    },
    createone: {
        'Create Class Failure': '班级创建失败',
        'Class Teacher Update Failure': '班级老师更新失败',
        'Class Student Update Failure': '班级学员更新失败',
        'Private Class': '私课',
        'Edit Student': '编辑学员',
        'Add New Private Class': '新增私课',
        'Edit Teacher': '编辑老师'
    },
    editone: {
        'Edit Private Class': '编辑私课',
        'Private Class': '私课',
        'Student Name': '学员姓名'
    },
    classroom: {
        'Classroom: {classroom} Has Been Created': '教室： {classroom} 创建',
        'Classroom: {classroom} Has Been Updated': '教室： {classroom} 已更新',
        'Create Classroom: {classroom} Successful': '新建教室： {classroom} 成功',
        "Classroom: {classroom}'s Info Has Been Saved'": '修改教室： {classroom} 的信息已保存',
        'Classroom: {classroom} Deleted': '删除教室： {classroom} 完成',
        'Proceed to delete classroom?': '确认删除教室？',
        'Delete': '删除',
        'Classroom ({amount})': '教室 ({amount})',
        'New Classroom': '新增教室',
        'Classroom Name': '教室名称',
        'Enter Classroom Name': '输入教室名',
        'Edit Classroom': '编辑教室',
        'Amount': '退款金额',
        'Classroom List': '教室列表',
        'Classroom': '教室',
        'Personalized Classroom Management': '个性化的教室',
        'Effective Classroom Management allows you to manage your school for efficiently. Depends on the purpose, you can create a classroom for different events as well.': '有效的教室管理可以节省不必要的资源浪费。根据不同的用途，定制个性化的教室/场地名称。也可以在课表里根据教室来筛选课程。',
        '': '',
    },
  teacher: {
    'Teacher': '老师',
        'Teacher: {tname} Has Been Created': '老师: {tname} 已创建',
        'Create Teacher Failure': '添加老师失败',
        'Please exit from all current classes before archiving the teacher': '请您先退出当期班级，才可在学校中删除',
        "Teacher: {tname}'s Info Has Been Saved": '老师： {tname} 的信息已保存',
        "Teacher: {tname}'s Unarchived Failure": '老师： {tname} 恢复失败',
        'Send Invitation To Teacher: {tname}?': '发送邀请给老师: {tname}?',
        'Invitation Failure: please enter a valid phone number': '邀请失败： 请输入正确的手机号码',
        'Created': '未邀请',
        'Invited': '邀请中',
        'Invite': '邀请',
        'Confirm': '已接受邀请',
        'Declined': '已拒绝邀请',
        'Male': '男',
        'Female': '女',
        'None': '无',
    'Options': '更多',
        'Attendance': '签到记录',
        'Upgrade to Premium': '升级高级版',
        'Upgrade': '升级',
        'Current': '当期老师',
        'Deleted': '已删除老师',
        'History': '历史老师',
        'New Teacher': '新增老师',
        'Teacher Name': '老师姓名',
        'Gender': '性别',
        'Mobile Phone Number': '手机号',
        'Phone Number': '手机号',
        'Lessons Taught Count': '已教课次数',
        'Lessons Taught Hours': '已教课时',
        'Please enter a valid phone number': '请输入正确的手机号码',
        'New Teacher': '新增老师',
        "Enter Teacher's Name": '输入老師姓名',
        'Save': '保存',
        'Save and Invite': '保存并邀请',
        'Edit Teacher': '编辑老师',
        'Date': '退款日期',
        'Amount': '收款金额',
        "Enter a phone number to invite the teacher to download the ClassTop mobile App. The teacher could then change the attendance, as well as sending and receiving announcements and schedules. You could change teacher's permissions inside the permissions settings": '填写手机号可以邀请老师下载手机端APP, 老师可以用APP给自己和学生签到, 接收通知和课表, 您可以在权限设置里安排老师的权限',
        'Phone number already existed': '此手机号已存在',
        'Phone number already existed in archived teacher': '此手机号已存在归档老师里',
        'Please enter phone number': '请输入手机号',
        'Teacher List': '老师列表',
        'Proceed to archive teacher?': '确认要归档老师？',
        'Proceed to unarchive teacher?': '确认要恢复老师？',
        "Restore": '恢复',
        'Archive': '归档',
        "Enter Teacher's Email Address" : '输入老师邮件地址',

        'Administration Management': '多角色教务管理',
        'Administration Management allows you to create teachers, which you can appoint them in different classes. You could also send an invitation via text to teachers, which allows them to join this platform and help you management your school. Teachers could also download ClassTop for School Staff app on both Apple Store and Google Play to help them better manage their classes': '学校可直接创建并保存一个教务角色，也可以邀请一名老师加入学校的教学管理，配合着专为老师定制的APP一起用，可提高数倍教学效率。',
        '': '',
        'N/A': '未提供'
    },
    finance: {
        'Receipt Number': '输入收据号',
        "Financial Management": '财务管理',
        'Add Credit': '校内钱包',
        'Showing {amount} records Total of {amount2} records': '显示 {amount} 条记录 全部 {amount2} 条记录',
        '{transaction_date} - {transaction_date2} - {transaction_date3}': '{transaction_date} 年 {transaction_date2} 月 {transaction_date3} 日',
        'Charge': '收费',
        'Refund': '退费',
        'Please enter remarks content': '请输入备注内容',
        'Send To': '发送至',
        'Send': '发送',
        'Transaction Summary': '交易纪录',
        'Student: ': '学员： ',
        'Operator: ': '经办人： ',
        'E-Receipt Number: ': '电子收据号： ',
        'All': '所有',
        'Class: ': '班级: ',
        'Date: ': '日期: ',
        'E-Receipt Number': '输入电子收据号',
        'Search': '搜索',
        'E-Receipt No.': '电子收据号',
        'Student': '学员',
        'Charge/Refund': '收费/退费',
        'Amount': '金额',
        'Payment Methods': '付款方式',
        'Purchased Lessons': '购买课程',
        'Operator': '经办人',
        'Receipt No.': '收据号',
        'Added': '创建',
        'Date': '收款日期',
        'Payment': '收款',
        "Statement Detail": "收支明细",
        'Remarks': '备注内容',
        'To': '至',

    },
    monthlyFinance:{
        'Search by Date': '筛选日期',
        'Monthly Income':'该月收入',
        'Monthly Spending':'该月支出',
        'Net Income':'该月净收入',
        'Monthly Summary':'月度汇总',
    },
  student: {
    'Exit Class Successful': '退出班级成功',
    'The student {student_name} has been removed from the class.': '{student_name}学员已退出班级',
    'New Student: {name} Has Been Created': '新学员： {name} 已创建',
        "Student: {name}'s Info Has Been Updated": '学员： {name} 信息已更新',
        'Exited Class': '已退出班級',
        'You Do Not Have the Permission to Visit This Page, Please Contact the School Principal/Manager for More Information': '您所在的用户组不具有此操作的权限，请联络该学校的校长或管理员授予您相应的权限',
        'Student {name} {remarks}': '学员 {name} {remarks}',
        'Student {name} {reason}': '学员 {name} {reason}',
        'Student Payment Failure': '学员缴费失败',
        'Student: {name} Archived': '学员： {name} 已归档',
        'Student: {name} Unarchived': '学员： {name} 已恢复归档',
        'Multiple Student Archived': '多个学员已归档',
        'Student Info Update Failure': '学员状态更新失败',
        'Added': '加入',
        'Proceed to archive student {student}?': '确认归档学员？',
        'The following students are currently enrolled in class: ': '以下的学员正在就读班级：',
        'Archive Multiple Students':'归档多个学员',
        'Archive Student':'归档学员',
        'Student {student} is currently in class, proceed to archive student?': '学员 {student} 正在班级里就读, 确认归档学员吗 ?',
        'Students {student} are currently in classes, proceed to archive students?': '学员 {student} 正在班级里就读, 确认归档学员吗 ?',

    table: {
      '{sAge} yrs old': '{sAge} 岁',
      '{days_left} day remaining': '余 {days_left} 天',
      '{days_left} days remaining': '余 {days_left} 天',
      '{qty} / {total} hour': '{qty} / {total} 小时',
      '{qty} / {total} hours': '{qty} / {total} 小时',
      '{qty} / {total} lesson': '{qty} / {total}  次',
      '{qty} / {total} lessons': '{qty} / {total}  次',
    },

    "Proceed to join '{className}'?": "确认加入'{className}'吗？",
        'Please select a class and enter the amount for refund': '请您首先选择班级，并填入退款金额',
        'Please enter the appropriate refund amount': '请您填入合适退款金额',
        'Refund date cannot be empty': '退款日期不能为空',
        'Please select a class and enter the amount charged': '请您首先选择班级，并填入收款金额',
        'Please enter the appropriate charged amount': '请您填入合适收款金额',
    'Charged date cannot be empty': '付款日期不能为空',

    // Archive
        'Proceed to archive student: {name}?': '是否将学员： {name} 归档？',
    'Proceed to archive students: {name} and {otherStr}?': '是否将学员： {name}等{otherStr}归档？',
    '{number} other': '{number}人',
    '{number} others': '{number}人',

    // Unarchive
    "Unarchive": '恢复归档',
    "View": '进入档案',

        'Please exit all classes in order to archived student': '请您先在班级中归档，才可在学校中归档',
        'Proceed to restore student: {name}？': '是否恢复学员： {name}？',
        'Showing {amount} students Total of {amount2} students': '显示 {amount} 人 全部 {amount2} 人',
        'Price ${fee}': '课价 ${fee}',
        'Exit student from class?': '确认将此学生退出班级吗？',
        'Exit Class': '退出班级',
        'Join Class': '加入班级',
        'Add Credit': '钱包充值',
        'Charge': '收费',
        "Add the credit to the student's account and can be used towards other expenses": '给此学生的校内钱包充值，并通用与任何校内费用的结算',
        'Collecting tuition fee and renewal': '直接收取学费以及用于续费等',
        'Account Remaining: ': '钱包余额： ',
        'Enter recipient email': '输入收件人邮箱',
        'Paper Receipt Number': '输入收据号',
        'Date': '充值日期',
        'Email': '邮箱',
        'Amount': '充值金额',
        'Purchased Lesson Until...': '购买课期至',
        '': '次',
        'Hour': '小时',
        'Exit Lesson Until...' : '退课期至',
        'Exit Lesson Number': '退课次',
        'Choose one...': '请选择...',
        'Purchased Lesson': '已购买课期',
        'Renew Lesson Until...': '续课期至',
        'Purchased Lesson Hour': '购买课时',
        'Hour': '小时',
        'Add remarks': '添加备注',
        'Edit Lesson Until...': '修改课期至',
        'Reduce Lesson Number': '减少课次',
        'Reduce Lesson Hour': '减少课时',
        'Join Current Classes': '加入当期班级',
        'Search Class Name': '搜索班级名称...',
        'Search name...': '搜索学员名称...',
        'Currently Enrolled': '正在就读',
        'Upgrade': '升级',
        'New Class': '创建班级',
        'New Student': '新增学员',
        'Multiple Students Has Been {action} To Class: {cname}': '多个学员被 {action} 到班级： {cname}',
        'View Now': '立即查看',
        'Failure: Students Are Already Enrolled In Class': '失败： 学员已经加入该班级',
        'Registered': '在读学员',
        'Not Enrolled': '未排班学员',
        'Enrolled': '已排班学员',
        'Pending Renewal': '待续费学员',
        'History': '历史学员',
        'Deleted': '已删除学员',
        'Student': '学员',
        'Age': '年龄',
        'Class': '班级',
    'Class Status': '课节消耗',
    'Refund': '退款',
    'Payment': '学费',
    'Paid Amount': '已缴学费',
    'Settings': '操作',
        '{i}': '{i}日',
        'Student List': '学员列表',
        "Archive": "归档",
        "New Private Class": "新建私课",
        "Edit": "编辑",
    "Attendance": "查看签到记录",
    'Remove "{sName}" From "{className}"?': '确认将此学生({sName})退出班级({className})吗？',
    'Add': '加入',
    'show all ({classNumber})': '展开所有 ({classNumber})',
        'Registration Guide': '自助报名设置',
        'Self-registration Setup': '自助报名设置',
        'Step One': '第一步',
        'Step Two': '第二步',
        'Step Three': '第三步',
        'Step Four': '第四步',
        'Enter Self-registration Address on Your Tablet Device': '在平板设备里输入自助报名网址',
        'Open any browser (Safari, Chrome, Firefox) on your tablet device and enter the following URL ': '在平板设备里打开任意浏览器（Safari，Chrome，Firefox），输入地址 ',
        'Log In to Your School': '登录您的学校',
        'Enter phone number and password, and then select the school to enter the student registration page': '填写手机号与密码，登陆后请选择相应学校进入学生注册页面',
        'Enter Student Information': '填写学生注册信息',
        'After student registered successfully, student information will be saved and displayed on the student page': '学生注册成功后，信息会存入您学校的学生列表里同时为您建立新学员。',
        'Privacy Setting (only on iPad)': '安全设置 (仅限于 iPad)',
        'If you do not wish others to change your account information, you could setup privacy setting on your iPad by following the steps below: ': '如果您不想学生，家长，或者其他人员乱碰您 iPad 里的其他东西，您可以使用引导式访问，具体 iPad 设置如下：',
        "On your iPad, press 'Settings' > 'General' > 'Accessibility' > 'Guided Access' to set up Guided Access, you could do the following: " : '在iPad上轻按“设置”>“通用”>“辅助功能”>“引导式访问”以设置引导式访问。在此处，您可以执行以下操作：',
        '• Turn on/off Guided Access': '• 开启或关闭引导式访问',
        '• Setup passcode for Guided Access, such as preventing others from exiting the application': '    • 设置密码以控制引导式访问的使用，并防止有人离开活跃的会话',
        '• Setup time limits so the application will be disabled once the time expires': '•     设置设备是否可以在会话过程中进入睡眠状态',
        'To enable Guided Access, please follow the steps below: ': '要启动引导式访问会话，请按照以下步骤操作：',
        '1. Open the application': '1. 打开想要使用的 app。',
        '2. Press Home Button three times': '2. 连按三次主屏幕按钮。',
        "3. Enter the passcode, set up Guided Access, and then press 'Start'": '3. 输入密码，调整会话的设置，然后轻按“启动”。',
        'You could use Guided Access to control the application, such as disabling areas of the screen that aren’t relevant to a task, or areas where an accidental gesture might cause a distraction. Please follow the steps below: ': '您可以使用引导式访问来关闭 app 控件、屏幕的各个部分和动作感应功能。请按照以下步骤操作：',
        'To restrict the application and disable areas of the screen, please follow the steps below': '要停用 app 控件及 app 屏幕的各个区域，请按照以下步骤操作：',
        '1. Circle areas of the screen': '1. 在屏幕上圈出想要停用的部分。',
        '2. Adjust the areas by dragging the circle': '2. 使用控制柄来调整区域。',
        'To disable any screen interaction, please turn off the Touch button': '要忽略所有屏幕触摸，请关闭“触摸”。',
        "To disable screen lock in the application or any motion, press the 'Hardware Buttons' and turn off 'Motion' button": '要防止 iOS 设备从竖排切换到横排，或从响应切换到任何其他动作，请关闭“动作”。',
        "If Touch ID is enabled on your iPad, then it could be used to end Guided Access. Go to 'Settings' > 'General' > 'Accessibility' > 'Guided Access' > 'Passcode Settings'and turn on the Touch ID button. Now you could do the following steps to end Guided Access": '如果您正在使用 iOS 设备上的 Touch ID，则可以用它来结束引导式访问会话。首先，前往“设置”>“通用”>“辅助功能”>“引导式访问”>“密码设置”，并打开 Touch ID。现在，当您在使用引导式访问时，就可以按照以下步骤来结束会话：',
        '1. Press the Home Button': '1. 按一次主屏幕按钮。',
        '2. Use Touch ID': '2. 使用 Touch ID。',
        'If Touch ID is disabled on your iPad, you can end the Guided Access by the following steps': '如果未在设备上使用 Touch ID，请按照以下步骤结束引导式访问会话：',
        '1. Press the Home Button three times': '1. 连按三次主屏幕按钮。',
        "2. Enter the passcode and press 'End'": '2. 输入引导式访问密码。',
    'Add': '加入',
        'Proceed to exist class?': '确认退出班级？',

        'Student Record Documentation and Management': '学员档案记录与管理',
        'Student Management includes entry, search, edit multiple students, and register students through iPad. Student Management divides all students into different categories: current, not enrolled, enrolled, and past students. It allows you to enroll students, as well as payments and attendance. It also allows you to check student status.': '学员管理包括录入，查询，及批量学员同时操作，并可以设置前台 iPad 登记与报名。学员被划分为当期，未排班，在读，以及历史的多种状态类型。通过简单的操作给学生排班，充值，缴费，办理签到等各种事项。随时可以查询学生的上课状态，缴费，学费，退费，充值等记录。',
        '': '',
    },
    createstudent: {
        'Please enter a valid Email address': '请输入正确的邮件地址',
        'Please enter a valid phone number': '请输入正确的手机号码',
        'Please upgrade to premium version': '请升级高级版',
        '{i}': '{i} 年',
        'January': '1月',
        'February': '2月',
        'March': '3月',
        'April': '4月',
        'May': '5月',
        'June': '6月',
        'July': '7月',
        'August': '8月',
        'September': '9月',
        'October': '10月',
        'November': '11月',
        'December': '12月',
        'First Name': '名称',
        'Last Name': '姓氏',
        'Date of Birth': '生日',
        'Home Phone Number': '家庭电话',
        'Email': '邮件',
        'Nickname': '昵称',
        'Source': '来源',
        'Parents Name': '家长名字',
        'Relationship': '亲属关系',
        'Address': '居住地址',
        'Register Date': '注册日期',
        'Basic Information': '基本信息',
        'Student Birthday Incomplete': '学员生日填写不完整',
        'Select Year': '选择年',
        'Select Month': '选择月',
        'Select Date': '选择日',
    },
    settings: {
        'Password': ' 密码',
        'Reset Password': '重新设置密码',
        'Password Updated': '密码更新成功',
        'Reset Password Failure': '密码更新失败',
        'Enter New Password': '输入新密码',
        'Verification Code Sent': '验证码短信发送成功，请注意查收',
        'User does not exist, please check the phone number': '用户不存在，请检查电话号码',
        'Account Settings': '账户设置',
        'Plan Settings': '账单设置',
        'Free Trial': '试用版',
        'Discount Plan': '优惠版',
        'Customized Plan': '定制版',
        'Basic Plan': '基础版',
        'Professional Plan': '专业版',
        'Premium Plan': '高级版',
        'Basic' :' 基础版',
        'Customized': '定制版',
        'Professional': '专业版',
        'Premium': '高级版',
        'monthly': '每月',
        'yearly': '每年',
        'Choose Plan': '选择计划',
        'Current Plan': '当前计划',
        'per month, billed monthly': '每月, 按月付',
        'per month, billed yearly': '每月, 按年付',
        'Unlimited': '无上限',
        'Registered Students': '在读学生',
        'Registered Teachers': '在职老师',
        'Campus': '校区',
        'USD': '美元',
        '/month': '/每月',
        'Congratulations!': '恭喜您',
        'You are on {planName} now!': '您已成功更换至{planName}!',
        'Your current account can not be changed to this plan!': '对不起, 您的账号无法更换至此计划',
        'Failed to change plan!': '更换计划失败!',
        'Subscribe to {name}': '订阅{name}',
        'Per Month': '每月',
        "Today's total": '今日扣款',
        'Next billing date': '下次扣款日期',
        'Monthly': '月付',
        'Yearly': '年付',
        '4 digits': '4位数字',
        'show': '显示',
        'hide': '隐藏',
        'At least 6 characters': '至少6个字符',
        'Send Code': '发送验证码',
        'Unexpected errors': '操作失败',
        'Password has to be at least 6 characters long': '密码长度至少为六位',
        'User does not exist': '用户已存在',
        'Invalid verification code': '验证码错误',
        'Verification code is expired': '验证码已过期',
    },
    passwordsettings:{
        "Reset Password": '重置密码',
        "Verification Code": '验证码',
        'Verification Code Send To ': '验证码发送至',
        'Send Code': '获取验证码',
        'Resend': '重新获取',
        "New Password": '新密码',
        'Resent in {counterTime} s': '{counterTime} 秒后可重发'
    },
    planDetails: {
        'Features that are included in free trial': '免费试用版包含以下功能',
        'All basic plan features': '所有基础版本的功能',
        '{amount} Registered Students': '{amount}个在读学员',
        '{amount} Registered Teachers': '{amount}个在职老师',
        '{amount} Campus': '{amount}个校区',
        'Features that are NOT included': '不包括以下功能',
        'No Posters': '无海报',
        'No Contacts': '无联系人',
        'No Smart Check-in': '无智能签到',
        'No Recent Activity Logs': '无操作记录查询',
        'Start My Trial': '开始我的试用',
        'Start your 14 days free trail now!': '开始你的14天免费试用吧!',
        'Create your school by starting your 14 days free trail now!': '14天免费试用, 开始创建属于您的学校吧!',
        'Create Your School': '创建你的学校'
    },
    studentdetail:{
        'Paid Amount': '已缴学费',
        'Refund Amount': '退款学费',
        'Refund Lesson Date': '退款课期',
        'Refund Lesson Number': '退款课次',
        'Refund Lesson Hour': '退款课时',
        'Send To': '发送至',
        '{transaction_date1} - {transaction_date2} - {transaction_date3}': '{transaction_date1} 年 {transaction_date2} 月 {transaction_date3} 日',
        'Search Class': '所有',
        'Options': '充值方式',
        "Amount": '充值金額',
        'Student: {name}': '学员： {name}',
        'Account Balance {balance} CAD': '钱包现有金额: {balance} CAD',
        'Please enter amount': '请填入收款金额',
        'Amount needs to be greater than 0': '金额必须大于零',
        'Historical Class Record': '历史班级',
        "Attendance Record": "签到记录",
        'Tuition Record': '学费记录',
        'Edit Basic Information': '修改基本信息',
        'Account Balance: ': '钱包现有金额： ',
        'Paper Receipt No': '纸质票据号',
        "Basic Information": '基本信息',
        "Current Classes": '当期班级',
        "Past Classes": '历史班级',
        "Attendance Record": '签到记录',
        "Tuition Record": '学费记录',
    },
    UI: {
        alert: {
            "Confirm": "确定",
        },
        confirm: {
            "Confirm": "确定",
            "Cancel": "取消",
        }
  },
  PaymentModal: {
        'Student: {student_name} Refunded {amount} {currency} Successfully!': '学员： {student_name} 退款 {amount} {currency} 成功',
        'Student: {student_name} Added Credit {amount} {currency} Successfully!': '学员： {student_name} 充值 {amount} {currency} 成功',
        'Student: {student_name} Charged {amount} {currency} Successfully!': '学员： {student_name} 收费 {amount} {currency} 成功',

    'Credit Added': '充值成功',
    'Charge Successful': '收费成功',
    'Refund Successful': '退费成功',

    'Insufficient balance in your account, please add credit and try again': '当前您的钱包余额不足，请充值后再使用',
        "Selected 'Reduce Lesson' is more than 'Purchased Lesson'": '选择的“减少课期”大于“已购买课期',
        'When making a payment through your account, make sure you have sufficient balance. Please add credit to your account to continue': '当使用钱包余额时，收款金额不能大于钱包余额 为了正常交易，您可以先充值在使用钱包或使用其他交易方式',
        'Charged Amount': '收款金额',
        'Charged Date': '收款日期',
        'Top Up Amount': '充值金额',
    'Top Up Date': '充值日期',
    'Payment Method': '付款方式',
    'Email': '邮箱',
    'Paper Receipt Number': '纸质收据号',
        'Student Payment Failure': '学员缴费失败',
    'Remarks': '备注',
    'E-receipts will be sent to the parents through email': '电子收据会通过邮件发给家长',
    'Cash': '现金',
    'Credit Card': '信用卡',
    'Cheque': '支票',
    'Bank Transfer': '转帐',
    'School Credit': '校内钱包',
    'Class': '班级',
    'Purchase Lesson Until...': '购买课期至',
    'Number Of Lesson': '购买课次',
    'Hour Of Lesson': '购买课小时',
    'Proceed to add {amount} {currency} credit?': '确认充值 {amount} {currency}吗？',
    'Proceed to charge {amount} {currency}?': '确认收 {amount} {currency} 吗？',
    'WeChat Pay Transfer': '微信转账',
    'Alipay Transfer': '支付宝转账',
    refund: {
      'Refund Amount': '退款金额',
      'Tuition Fee Refund': '直接退学费',
      'Refund the paid fee for this student':'退回此学生所缴班级学费',
      'Refund the collected credit for this student':'退回此学生钱包余额',
      'Refund Date': '退款日期',
      'Refund Lesson Until...': '退课期至',
      'Number Of Lesson': '退课次',
      'Number Of Hour': '退课小时',
      'Refund Method': '退款方式',
      'Proceed to refund {amount} {currency}?': '确认进行退款 {amount} {currency} 吗?',
    },
    units: {
      'HOUR': '小时',
      'HOURS': '小时',
      'LESSON': '次',
      'LESSONS': '次',
    },
    hourPaddingRight: {
      '52': '39',
      '59': '39',
      '66': '25',
      '73': '25',
    }
  },
  tutorialModal: {
    'Video Tutorial': '视频教程',
    'Tutorial': '使用教程',
    'Got it': '知道了',
  },
  SelectItemModal: {
    'Select': '选择',
    'Selected': '已选择',
    'Confirm ({number})': '确认 ({number})',
  },
  Table: {
    'Showing {begin} - {end} (total {total})': '显示 {begin} - {end} 全部 {total}',
    'No Result': '无数据',
  },
  ClassInfo: {
  },
  TextFilter: {
        'Search': '搜索',
  },
  data: {
    'N/A': '无',
  },
  DateRange: {
    'Date': '日期',
        'Start Date': '开始日期',
        'End Date': '结束日期',
  },
  TimeRange: {
    'Time': '时间',
    'Start Time': '开始时间',
    'End Time': '结束时间',
  },
  weekdays: {
    'Mon': '星期一',
    'Tue': '星期二',
    'Wed': '星期三',
    'Thu': '星期四',
    'Fri': '星期五',
    'Sat': '星期六',
    'Sun': '星期天',
    'Monday': '星期一',
    'Tueday': '星期二',
    'Wednesday': '星期三',
    'Thursday': '星期四',
    'Friday': '星期五',
    'Saturday': '星期六',
    'Sunday': '星期天',
  },
  form: {
    'errorMessage': {
      'Please fill this field': '此项为必填项',
      'Please enter a valid Email address': '请输入正确的邮件地址',
    },
  },
  schoolInfo: {
    'After-school Session': '课后辅导班',
    'Pre-school': '学前班',
    'Tutor': '家教',
    'Public/Private School': '公校/私校',
  },
  address: {
        'Country': '国家',
        'Province/States': '地区',
    'City': '城市',
    'Street': '街道地址',
    'Unit No.': '门牌号',
    'Postal Code': '邮政编码',
  },

  schooltypes: {
    'academic': '学术',
    'after_school_care': '课后辅导',
    "board_games": '棋牌类',
    "college": '学院',
    "college_prep": '大学预科',
    "cooking": '烹饪',
    "dance": '舞蹈',
    "daycare_and_babysitting": '托儿所',
    "events": '活动',
    "fine_arts": '美术',
    "fitness": '健身',
    "languages": '语言',
    "martial_arts": '武术',
    "math": '数学',
    "music": '音乐',
    "outdoor_activities": '户外运动',
    "performing_arts": '表演',
    "photography_and_movie_making": '摄影与影视',
    "private_school": '私校',
    "programming": '编程',
    "public_school": '公校',
    "reading": '阅读',
    "science": '科学',
    "sports": '体育',
    "university": '大学'
  },

    poster: {
        "Create a Beautiful Poster Design Is This Simple": '无需设计师也能制作精美营销海报',
        "Not only will you be able to create a beautiful poster to share, it can also be used to sign up classes and activities, buying event tickets, and published surveys. Posters can be saved as a draft, or published and shared on WeChat, Facebook, and Twitter. Let's get started!": '不仅能排出精美的宣传海报，还附带各种报名功能，如课程/班级的报名注册，活动的报名，在线售票，以及调查问卷，制作好的海报可以存为草稿定时发布和分享到Wechat, Facebook and Twitter上。还等什么，快来体验吧',
        "All": "全部海报",
        "Edit": "编辑",
        "Published": '已发布海报',
        "Closed": "已下架海报",
        "Draft": '草稿海报',
        'Delete': '删除',
        'Are you sure you want to delete the poster?': '确认删除海报？',
        'Unlink': '下架',
        'Are you sure you want to unlink the poster? The link will become invisible.': '确认下架海报？',
        'New Poster': '创建海报',
        "Select Poster Type": '选择海报类型',
        "Basic Poster": '普通海报',
        "Enrollment Registration": '招生注册',
        "Event Registration": '活动门票',
        "Survey": '调查投票',
        "Share": '分享',
        'Create': '创建',
        "Create a poster that contains only texts and pictures": '创建一个仅包含图文信息的海报',
        "Create a poster that allows users to register for classes or events": '创建一个可以让用户填写报名信息的海报',
        "Create a poster that allows users to register tickets": '创建一个可以让设置免费或收费门票的海报',
        "Create a poster that contains a survey or questionnaire": '创建一个带有调查问卷选项的海报',
        'Class Registration':'课程报名',
    'Event Registration':'活动报名',
    type: {
      'Enrollment Registration': '招生注册',
      'Event Registration': '活动报名',
      'Survey': '调查投票',
      'Basic Poster': '普通海报',
    },
    dateCard: {
      'Registration Start Time': '报名开始日期',
      'Total Registered': '目前报名',
      'Total Registered: {numberStr}': '目前报名: {numberStr}人',
            'Course Fee: ${price}': '课程费用: ${price}',
    },
    register: {
      'Item': '项目',
      'Items': '项目',
      'Register Now': '立即报名',
      'Registered': '报名人数',
      'Deadline': '报名结束日期',
      'None': '无限期',
      'Note: Currently we only accept online registration and offline payment.': '提示：报名目前只接受线上注册，线下缴费。',
      'No Limit':'无上限',
    },
  },
    ticket:{
        'Registration Setup':'报名设置',
        'Registration': '报名登记',
        'Registration with Fees': '报名并在线缴费',
        'Registration Title': '报名标题',
        'Amount of People': '人数',
        'Price Description': '费用说明',
        'Settings': '操作',
        '': '人',
        'Dance Class, English Class, etc': '舞蹈班，语文基础课，全年招生…',
        'Pay Offline': '线上注册，线下缴费',
        'Pay Online': '线上注册，线上缴费',
        'Advance Settings': '详细设置',
        'Registration Start Time': '报名开始时间',
        'Registration End Time': '报名结束时间',
        'No End Time': '无结束时间',
        'Price': '金额',
        'Waiting List': '等候名单',
        'Allow Waiting List': '超出招生人数时，自动进入等候名单',
        'No Waiting List': '超出招生人数时，报名自动关闭，无等候名单',
        'Close Advance Settings': '收起详细设置',
        'Other Settings': '其他设置',
        'Registration Progress': '报名进度',
        'Show Registration Progress on Poster': '在海报上显示报名进度，所有人可见。',
        'Read Count': '阅读数',
        'Show Read Count on Poster': '在海报上显示阅读数，所有人可见。',
        ' (No limit if empty)': '（不填则无上限）',
        'Proceed to delete this registration?': '确认删除报名？',
    },
    registrationTable:{
        'Item': '项目',
        'Applicant': '报名人',
        'Contact Name': '联系人',
        'Contact Email': '联系人邮箱',
        'Contact Phone No.': '联系人电话',
        'Status': '状态',
        'Settings': '操作',
        'Registration List': '报名人列表',
        'Detail': '详情',
        'Transfer Student': '转为学员',
        'Transferred': '已转为学员',
        'Success': '报名成功',
        'Waiting List': '等候名单',
        'Search Name, Email, or Phone No.': '搜索姓名，邮箱，电话',
        'All Items': '全部项目',
        'Date of Birth': '生日',
        'Phone No.': '手机',
        'Email': '邮箱',
        'Close': '关闭',
        '{student}': '{student} 学员',
        '': '',
        'Poster Registration List': '海报报名学员列表',
        'Registration Status': '报名状态',
        'Poster Title': '海报标题',
        'All Posters': '所有海报',
        'Select Poster': '选择海报',
        'Sort by': '排序',
        'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
        'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
    },

  openHours: {
    'closed': '休息',
  },

  LessonFloat: {
        "Edit": '编辑',
        'Attendance': '签到',
    'Start Time': '开始时间',
    'End Time': '结束时间',
    'Number of Student': '学生人数',
        'Classroom': '教室',
    'Teacher': '老师',
  },
    closeClass:{
        ' This class still has at least one unfinished lesson': ' 此班级还有未结束的课节',
        "After closing the class, you can find it under the 'Closed Class'": "关闭班级后，此班级会显示在 '已关闭班级'",
        'Are you sure you want to close the class below?': '确认关闭班级？',
        'Close Class': '关闭班级',
        'Attended':'补签',
    },
    teacherAttendance:{
        'Teacher / {teacher}': '老师 / {teacher}',
        "Attendance Record": "签到记录",
        'Class Name': '班级名称',
        'Lesson': '课节',
        'Lesson Time': '上课时间',
        'Attend Time': '签到时间',
        'Status': '状态',
        'Late':'迟到',
        'Unattended':'未出勤',
        'Attended':'出勤',
        'Absent':'请假',
        'Total Attended Count/Duration: {count}':'总出勤：{count}次',
        'Total Unattended Count/Duration: {count}':'总缺勤：{count}次',
        'Absent (with excuse) Count/Duration: {count} / {hour}':'请假缺勤：{count}次 / {hour}',
        'Absent (without notice) Count/Duration: {count} / {hour}': '旷课缺勤：{count}次 / {hour}',
        'Late Count/Duration: {count} / {hour}':'迟到：{count}次 / {hour}',
        'On Time Count/Duration: {count} / {hour}':'正常：{count}次 / {hour}',
        'Today':'截止今日',
        'Attendance Status':'签到状态',
        'Select Status': '选择状态',
        'Export Student List to Excel':'导出学生列表至 Excel',
        'Only search within three months period':'您每次只能查询三个月以内的记录',
        '':'',
        '':'',
        'Attendance Overview': '签到总汇',
        'Attendance Detail': '签到详情',
        'On Time Count & Duration': '正常出勤数&时长',
        'Total Attended Count & Duration': '总出勤数&时长',
        'Late Count & Duration': '迟到数&时长',
        'Total Unattended Count & Duration':'总缺勤数&时长',
        'Absent (with excuse) Count & Duration': '请假缺勤数&时长',
        'Absent (without notice) Count & Duration': '旷课勤数&时长',
        'On-Time Count': '正常出勤数',
        'Total Attended Count': '总出勤数',
        'Late Count': '迟到数',
        'Total Unattended Count':'总缺勤数',
        'Absent (with excuse) Count': '请假缺勤数',
        'Absent (without notice) Count': '旷课勤数',
        'On-Time Duration': '正常出勤时长',
        'Total Attended Duration': '总出勤时长',
        'Late Duration': '迟到时长',
        'Total Unattended Duration':'总缺勤时长',
        'Absent (with excuse) Duration': '请假缺勤时长',
        'Absent (without notice) Duration': '旷课勤时长',
        'Hourly Rate:': '时薪:',
        'Total Salary:': '总工资:',
        'Please enter value': '请输入数值',
        'Total Salary': '当前工资',
        'Calculate Salary': '计算工资',
        'Salary Calculation': '工资计算',
        'The calculated salary will not be saved to our system, please export it after the calculation': '工资计算完成后请及时导出, 系统不会保存计算结果',
        'Makeup Count: {count}':'补签：{count}次',
        'Makeup Count': '补签数',
        'Please fill the fields you need for the calculation.': '请输入各项工资所需金额, 如果没有该项目, 请填写零。',
        'Hour/Count': '小时/次数',
        'Rate': '单价',
        'Base Salary': '底薪',
        'Salary (By Hours)': '按小时工资',
        'Salary (By Counts)': '按课次工资',
        'Late Penalty (By Hours)': '迟到小时扣款',
        'Late Penalty (By Counts)': '迟到次数扣款',
        'Absent (with excuse) Penalty (By Hours)': '请假小时扣款',
        'Absent (with excuse) Penalty (By Counts)': '请假次数扣款',
        'Absent (without notice) Penalty (By Hours)': '旷课小时扣款',
        'Absent (without notice) Penalty (By Counts)': '旷课次数扣款',
        'Benefit': '福利',
        'Tax': '税',
        'Other Additions': '其他增项',
        'Other Deductions': '其他扣减',
        'Total Salary:': '总工资:',
        'Export Student List to CSV': '导出学生列表至 CSV',
        'Absent Penalty (By Hours)': '旷课小时扣款',
        'Absent Penalty (By Counts)': '旷课次数扣款',
        'Leave Early Penalty (By Hours)': '早退小时扣款',
        'Leave Early Penalty (By Counts)': '早退次数扣款',
        'Unchecked: {count}': '无记录次数: {count}次',
        'Unchecked Count & Duration': '无记录次数和时长',
        'Unchecked Count': '无记录次数',
        'Unchecked Duration': '无记录时长',
        'Unchecked Count: {count}': '无记录次数: {count}次',
        'Unchecked Duration: {hour}': '无记录时长: {hour}',
        'Absent (with excuse)': '请假',
        'Absent (without notice)': '旷课',
        'Unchecked': '无记录',
        'Export Record to Excel': '导出记录至 Excel',
        'Export Record to CSV': '导出记录至 CSV',
        'Export Record': '导出记录',
    },
    lesson: {
        'Lesson {lesson_amount}, {student_amount} students': '课节{lesson_amount} 学员{student_amount}名',
        '': '',

    },
    studentTable: {
        'Join Class': '批量加入班级',
        'Create Class': '批量创建班级',
        'Delete Students': '批量删除学员',
        'Students: ': '班级学员：',
        'Teachers: ': '班级老师：',
        'New Teacher': '新增老师',
        'This student has paid tuition, do you wish to refund?': '此学员已缴费，是否要退费？',
        '': '',
        'Export Record to Excel': '导出记录至 Excel',
        'Export Record to CSV': '导出记录至 CSV',
        'Student Settings': '学员设置',
        'Student Custom Fields': '学员自定义字段',
        'Import Students': '导入学员'
    },
    lessonTable: {
        'Reset Time': '批量重置时间',
        'Reset Teacher': '批量重置老师',
        'Reset Classroom': '批量重置教室',
        'Reset Students': '批量重置学员',
        'Reset Color': '批量重置课节色',
        'Delete Lessons': '批量删除课节',
        'Reset Lesson Time': '重置课节时间',
        'Reset Lesson Color': '重置课节颜色',
        'Cancel': '取消',
        'Save': '保存',
        'Lesson color will be displayed in the calendar, making it organized and easy to view': '课程颜色会显示在课表日历里，帮助您分类且更直观的预览课表',
        'Deleted lessons are unrecoverable, proceed to delete?': '删除过的课节将无法再找回，你确定要删除吗？',
        'Lesson already exists in the selected time': '此时间段已排过课',
        'Unable to change lesson time on the same date': '相同的日期无法修改时间',
        'Conflict': '冲突',
        'Reset Lesson Teacher': '重置课节老师',
        'Reset Lesson Student': '重置课节学员',
        'Reset Lesson Classroom': '重置课节教室',
        'Empty': '清空',
        '': '',
    },
    attendanceScan:{
        'Smart Check In': '智能签到',
        'Automatic Check In': '进行扫码签到',
        'Scanning for attendance, please do not close this window': '扫码签到时，请不要关闭此窗口',
        'Students': '用户',
        'Class': '班级',
        'Lesson': '课节',
        'Time': '签到时间',
        'Student has already checked in or has no lesson': '此学员已签到或无课节',
        'Student does not exist in school or invalid code': '此学员不存在学校或二维码无效',
        'Student has missed the lesson': '此学员已错过课节',
        'Clock In/Clock Out': '上班/下班',
        'Clock In': '上班',
        'Clock Out': '下班',
    },

  dateFormat: {
    'MMM DD, YYYY': 'YYYY年MM月DD日',
    'ddd, MMM DD YYYY': 'YYYY年MM月DD日ddd',
  },

    image: {
        'Image file must be png/jpeg under 5 MB': '图像文件必须是5 MB以下的 png/jpeg',
        'Image not qualified': '图像不合格',
    },
    others: {
        'Not Assigned': '未分配'
    },

  // ========== UNSORTED ===========
  'Minimum': '下限',
  'Maximum': '上限',
}


export default locale



// WEBPACK FOOTER //
// ./src/locale/translations/CN.js